<script>
    import PageTitle from '../components/PageTitle.svelte';

    import { Routes, pushRoute } from '../router';
    import { page } from '../stores';

    let url = '';
    let errorMessage = '';
    $: disabled = !url;

    function viewAll() {
        pushRoute(Routes.LIST);
    }

    function search() {
        const index = url.indexOf('/view.html?l=');
        if (disabled || index === -1) {
            errorMessage = 'Invalid URL';
            return;
        }
        const l = url.slice(index + 13, index + 19);
        history.pushState({}, '', `?p=${Routes.LOCATION}&l=${l}`);
        page.update((n) => Routes.LOCATION);
    }
    
    function onToEditFooter() {
        pushRoute(Routes.EDIT_FOOTER);
    }
    
    function onToInviteUser() {
        pushRoute(Routes.INVITE_USER);
    }
</script>

<PageTitle text={'Find Panorama'} />
<div class="form-wrapper">
    <form on:submit|preventDefault={search}>
        <input bind:value={url} type="text" placeholder="https://">
        <input type="submit" value="Search" disabled={disabled}>
        <input type="button" value="View All" on:click={viewAll}>
    </form>
    {#if errorMessage}
        <div class="form-error-message">
            <span>{errorMessage}</span>
        </div>
    {/if}
</div>
<div class="quick-links">
    <div class="row">
        <div class="item" on:click={onToEditFooter} >
            <span>Edit Footer</span>
        </div>
        <div class="item" on:click={onToInviteUser} >
            <span>Invite User</span>
        </div>
    </div>
</div>

<style>
    .quick-links {
        margin: auto;
        padding: 10px;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
    }

    .row {
        width: 100%;
    }

    .item {
        font-weight: 700;
        font-size: 22px;
        width: 200px;
        margin: 5px;
        padding: 5px 0px;
        border: 3px solid white;
        border-radius: 10px;
        display: inline-block;
        -webkit-transition: all var(--fast);
        transition: all var(--fast);
    }

    .item:hover {
        cursor: pointer;
        background-color: white;
        color: var(--primary);
    }

    input[type=text] {
        width: 100%;
    }

    input[type=submit] {
        margin-top: 15px;
    }

    input[type=submit]:hover, input[type=button]:hover {
        cursor: pointer;
    }

    input[type=submit]:disabled, input[type=button]:disabled {
        background-color: var(--grey);        
    }
</style>
